// extracted by css-extract-rspack-plugin
export default {"gridRows":"disclosure-grid-module__gridRows__UnjZR","gridRowsExpanded":"disclosure-grid-module__gridRowsExpanded__f_qWS","clip":"disclosure-grid-module__clip__Ptnzq"};